"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMoneyInfo = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../utils/classFunctions");
const roundMoney_1 = require("../../../../utils/roundMoney");
const Button_1 = require("../../../Button");
const Field_1 = require("../../../Form/Field");
const Icon_1 = require("../../../Icon");
const PopupWrapper_1 = require("../../../Popup/PopupWrapper");
require("./index.scss");
const className = 'page-header-user-money-info';
const UserMoneyInfo = (props) => {
    const { modificators, userBalance = 0, showCharge = false, onConfirmCharge, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    const [showPopup, setShowPopup] = (0, react_1.useState)(false);
    const [chargeAmount, setChargeAmount] = (0, react_1.useState)('');
    const { locale } = (0, react_intl_1.useIntl)();
    const onClose = (0, react_1.useCallback)(() => {
        setShowPopup(false);
    }, []);
    const openPopup = (0, react_1.useCallback)(() => {
        setShowPopup(true);
    }, []);
    const onSubmit = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        const value = e.target[0].value;
        const result = Number(value);
        if (isNaN(result))
            return;
        setShowPopup(false);
        onConfirmCharge === null || onConfirmCharge === void 0 ? void 0 : onConfirmCharge(result);
    }, [setShowPopup, onConfirmCharge]);
    const onChangeChargeAmount = (0, react_1.useCallback)((e) => {
        setChargeAmount(e.target.value);
    }, []);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__balance` },
            react_1.default.createElement("div", { className: `${className}__avatar` },
                react_1.default.createElement(Icon_1.Icon, { name: 'dollar-circle-thin' })),
            react_1.default.createElement("div", { className: `${className}__content` },
                react_1.default.createElement("div", { className: `${className}__label` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Page/Header/UserMoneyInfo/Balance:text', defaultMessage: 'Balance' })),
                react_1.default.createElement("div", { className: `${className}__name` },
                    "CHF ",
                    (0, roundMoney_1.localizeMoney)(userBalance, locale, 'Page/Header/UserMoneyInfo')))),
        !!showCharge && (react_1.default.createElement("div", null,
            react_1.default.createElement(Button_1.Button, { onClick: openPopup, text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Page/Header/UserMoneyInfo/Balance:chargeButtonText', defaultMessage: 'Charge account' }), modificators: 'sm' }),
            react_1.default.createElement(PopupWrapper_1.PopupWrapper, { onClose: onClose, isCloseButtonVisible: true, isOpened: showPopup },
                react_1.default.createElement("form", { onSubmit: onSubmit, className: `${className}__charge-form` },
                    react_1.default.createElement("h3", { className: `${className}__popup-title` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Page/Header/UserMoneyInfo/Balance:popupTitle', defaultMessage: 'Charge Account' })),
                    react_1.default.createElement("p", { className: `${className}__popup-description` },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Page/Header/UserMoneyInfo/Balance:popupDescription', defaultMessage: 'Please enter the desired amount.' })),
                    react_1.default.createElement(Field_1.FormField, { value: chargeAmount, onChange: onChangeChargeAmount, addon: 'CHF', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Page/Header/UserMoneyInfo/Balance:chargeFieldLabel', defaultMessage: 'Amount' }) }),
                    react_1.default.createElement(Button_1.Button, { type: 'submit', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Page/Header/UserMoneyInfo/Balance:chargeConfirm', defaultMessage: 'Confirm' }) })))))));
};
exports.UserMoneyInfo = UserMoneyInfo;
//# sourceMappingURL=index.js.map